import classNames from 'classnames';
import React from 'react';
import type { GroupBase, OptionProps } from 'react-select';
import { components } from 'react-select';
import LocalSearchHighlight from '../../search/LocalSearchHighlight';
import type { FuzzySearchMatch } from '../../utils/search/fuzzySearch';
import SeriesIcon from '../SeriesIcon';
import * as styles from './SeriesOption.module.scss';

export const SERIES_MATCH_KEY = 'name';

const SeriesOption = <
  Option extends {
    isDisabled: boolean;
    series: { name: string };
    matches?: readonly FuzzySearchMatch[];
  },
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: OptionProps<Option, false, Group>,
) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div
        className={classNames(styles.container, {
          [styles.disabled]: data.isDisabled,
        })}
      >
        <div className={styles.icon}>
          <SeriesIcon />
        </div>
        <div className={styles.label}>
          <LocalSearchHighlight
            matchKey={SERIES_MATCH_KEY}
            matches={data.matches}
            defaultValue={data.series.name}
          />
        </div>
        {data.isDisabled && (
          <div className={styles.secondary}>Cannot edit this series</div>
        )}
      </div>
    </components.Option>
  );
};

export default SeriesOption;
